export const sortSubCategories = (subCategories?: PageContent.TTagWithImageAndSubTitle[]) =>
  subCategories?.sort((a, b) => Number(!a.image) - Number(!b.image) || a.id?.localeCompare(b.id)) ||
  [];

// it's needed because of eslint prefer-default-export rule
export default sortSubCategories;
